import ENUM from '@/enums/enums';

/* eslint-disable */
const ls = require('local-storage');

import * as types from './mutation-types';

export default {
  /**
   * Login
   */
  [types.LOGIN](state, { userToken, user }) {
    state.authenticated = true;
    state.user = user;
    state.userToken = userToken;
    if (userToken) {
      ls.set('userToken', userToken);
    }
  },
  /**
   * Logout
   */
  [types.LOGOUT](state) {
    state.authenticated = false;
    state.user = null;
    state.userToken = null;
    ls.remove('userToken');
  },
  /**
   * Update user data
   */
  [types.UPDATE_USER](state, user) {
    /**
     * Set user to null allows to be sure that changes are detected by the scope
     */
    state.user = null;
    state.user = user;
  },

  [types.GET_USERS](state, users) {
    /**
     * get users list
     */
    state.users = users;
    state.apiState = ENUM.LOADED;
  },
  [types.CLEAN_STORE](state) {
    /**
     * get users list
     */
    state.users = [];
  },
  BO_AUTH(state, token) {
    console.log('MUTATION: ', token);
    state.boToken = token;
  },
};
